/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react"
import { Route, Switch, useHistory, useLocation } from "react-router-dom"
import LogoMark from "../../source/img/logomark.png"
import Password from "./Password"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowLeft, faCog } from "@fortawesome/free-solid-svg-icons"
import { useDispatch } from "react-redux"
import { AppDispatch } from "../.."
import { clearAlert } from "../../globalStore/alertStore"

/**
 * 個人設定画面のサイドバーの単枠コンポーネント
 * @param props
 * @returns
 */
const SettingSideBarMenu = (props: { pathname: string; menuName: string }) => {
  const history = useHistory()
  const location = useLocation()
  return (
    <div
      className={[
        "setting-sidebar-menu",
        location.pathname === props.pathname && "select",
      ].join(" ")}
      onClick={() => history.push(props.pathname)}>
      <span>{props.menuName}</span>
    </div>
  )
}

/**
 * 個人設定画面
 * @returns
 */
const Settings = () => {
  const history = useHistory()
  const dispatch: AppDispatch = useDispatch()

  useEffect(() => {
    dispatch(clearAlert())
  }, [history.location])

  return (
    <div id="primaryContainer">
      <header id="settingsHeader">
        <div id="headerCompanyInformation">
          <span
            onClick={() => history.push("/top")}
            style={{
              cursor: "pointer",
            }}>
            <span
              style={{
                paddingLeft: "1rem",
                paddingRight: "1rem",
              }}>
              <FontAwesomeIcon icon={faArrowLeft} />
            </span>
            <span>ダッシュボードに戻る</span>
          </span>
          <img src={LogoMark} alt="" className="header-logomark" />
          <span>大川運輸 Kairos</span>
        </div>
      </header>
      {/* ページのボディ部 */}
      <div id="secondaryContainer">
        {/* サイドバー */}
        <div id="sideBar" className="settings-sideBar">
          <div
            style={{
              marginTop: "20px",
              marginLeft: "16px",
              marginBottom: "30px",
            }}>
            <FontAwesomeIcon icon={faCog} style={{ fontSize: "1rem" }} />
            <span
              style={{
                fontSize: "16px",
                verticalAlign: "middle",
                paddingLeft: "1rem",
              }}>
              個人設定
            </span>
          </div>
          {/* <SettingSideBarMenu
            pathname={"/settings/charge"}
            menuName="ユーザー情報"
          /> */}
          <SettingSideBarMenu
            pathname={"/settings/password"}
            menuName="パスワード"
          />
        </div>
        {/* 各ページのコンポーネントをここに表示する */}
        <div id="rootContainer" className="setting">
          <Switch>
            <Route
              exact
              path={["/settings", "/settings/password"]}
              component={Password}
            />
          </Switch>
        </div>
      </div>
      {/* バックグラウンドの画像表示 */}
      <div id="background" className="settings"></div>
    </div>
  )
}

export default Settings
